import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/auth-context";
import { CompanyList } from "../pages/entreprises/CompanyList";
import { CircularProgress, Box } from "@mui/material";

export const CompanyRedirect: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Si c'est un MODERATOR avec une entreprise, rediriger vers la page show
    if ((user?.role === "MODERATOR" || user?.role === "MODERATOR_FREE") && user?.entrepriseId) {
      navigate(`/company/${user.entrepriseId}`, { replace: true });
    }
  }, [user, navigate]);

  // Si c'est un MODERATOR avec une entreprise, afficher un loader pendant la redirection
  if ((user?.role === "MODERATOR" || user?.role === "MODERATOR_FREE") && user?.entrepriseId) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Sinon, afficher la liste normale des entreprises
  return <CompanyList />;
};